/** "Do cheap flight sites have cheaper fares? We checked 1,644 prices": metadata (the article is in ../bodies/do-cheap-flight-sites-have-cheaper-fares.js). */
export default {
  slug: 'do-cheap-flight-sites-have-cheaper-fares',
  category: 'Research',
  label: 'Research · November 2026',
  title: 'Do cheap flight sites have cheaper fares? We checked 1,644 prices',
  seoTitle: 'Are Cheap Flight Sites Really Cheaper? (2026 Data)',
  description: 'We compared 1,644 airline and agency prices on 140 flights. Agencies often beat the airline, but by a median of $11. The fare type mattered far more.',
  dek: 'We opened every booking option Google Flights listed for 140 itineraries and compared each seller with the airline. The cheaper prices were real, but small, and they came from somewhere you might not expect.',
  author: 'Stephanie Ludwig',
  published: '2026-11-03',
  updated: '2026-11-03',
  faqs: [
    {
      q: 'Are cheap flight sites actually cheaper than the airline?',
      a: 'Sometimes, but not by much. On 95 itineraries sold by both an airline and at least one agency, some agency listed a lower price on 69, but the median saving was $11 (4.2% of the fare). Search sites like Google Flights and Kayak don’t sell fares themselves; they show prices from airlines and agencies.',
    },
    {
      q: 'Is Expedia cheaper than the airline?',
      a: 'Usually not, in our data. Expedia matched the airline’s price exactly on 35 of the 57 itineraries it sold, was cheaper on 14 and was more expensive on 8, for a median difference of $0.',
    },
    {
      q: 'Which travel sites undercut the airline most often?',
      a: 'Smaller agencies. FlightHub undercut the airline on 32 itineraries, JustFly on 31, BudgetAir on 30 and Kiwi.com on 27. The savings were usually small, and we collected no data on any agency’s service.',
    },
    {
      q: 'What is the difference between a metasearch site and an online travel agency?',
      a: 'A metasearch site such as Google Flights or Kayak compares prices and sends you elsewhere to buy. An online travel agency such as Expedia or Priceline sells you the fare, takes your payment and is usually who you deal with for changes and refunds.',
    },
    {
      q: 'If I book through a travel agency, who gives me a refund?',
      a: 'Usually the agency. The US Department of Transportation says ticket agents that are the merchant of record, the company on your card statement, must make refunds when an airline cancels or significantly changes a flight, and advises contacting the agency first. DOT’s 24-hour cancellation requirement for airlines doesn’t apply to agency bookings, though agencies may offer something similar.',
    },
    {
      q: 'Does the website or the fare type matter more for price?',
      a: 'The fare type, in our data. Moving from basic economy to the airline’s standard economy fare cost a median $45, about four times the median $11 an agency saved when it beat the airline.',
    },
  ],
  related: [
    'basic-economy-real-cost',
    'fastest-flight-search-engines',
    'cheapest-day-to-fly',
  ],
};
